export default __webpack_public_path__ + "static/media/11-71.dc626765.jpeg";